import { camelize } from './common';

export enum ContentTypes {
  jsonDefault = 'application/json',
  json = 'application/json; charset=utf-8',
  vndJson = 'application/vnd.s.v1+json; charset=utf-8',
  vndJsonLegacy = 'application/vnd.softswiss.v1+json; charset=utf-8',
  vndJsonV2 = 'application/vnd.s.v2+json; charset=utf-8',
  vndJsonV2Legacy = 'application/vnd.softswiss.v2+json; charset=utf-8',
}

const jsonContentTypes = new Set<string>([
  ContentTypes.vndJson,
  ContentTypes.vndJsonLegacy,
  ContentTypes.vndJsonV2,
  ContentTypes.json,
]);

export function getResponseDefault() {
  return (data: unknown, headers?: Record<string, string>) => {
    const contentType = headers?.['content-type'];

    if (contentType === undefined || !jsonContentTypes.has(contentType)) {
      return data;
    }

    try {
      return JSON.parse(data as string);
    } catch {
      return {};
    }
  };
}

export function getResponseCamelization(blacklists?: string[][]) {
  return (data: unknown, headers?: Record<string, string>) => {
    const contentType = headers?.['content-type'];

    if (contentType === undefined || !jsonContentTypes.has(contentType)) {
      return data;
    }

    try {
      return camelize(JSON.parse(data as string), blacklists);
    } catch {
      return {};
    }
  };
}
